interface LogMessage {
  message: string;
  /**当前请求url */
  url: string;
  /**请求体 */
  req: any;
  [key: string]: any;
}

enum LogLevel {
  info = 'info',
  warn = 'warn',
  error = 'error',
}

const isDEV = process.env.NODE_ENV === 'development';
// 上报日志
const msLogger = (level: LogLevel | string, originMessage: LogMessage) => {
  if (!isDEV) {
    // 非 dev 模式 则 上传日志
    const logInfo = {
      time: Date.now(),
      version: process.env.SENTRY_VERSION,
      ...originMessage,
    };
    try {
      switch (level) {
        case LogLevel.error:
          window.AdReach?.logger.error(logInfo);
          break;
        case LogLevel.warn:
          window.AdReach?.logger.warn(logInfo);
          break;
        default:
          window.AdReach?.logger.info(logInfo);
          break;
      }
    } catch (e) {
      // ignore
    }
  }
};

export { msLogger };
